import * as React from 'react';
import { DiscountBadgeVariant, IDiscountBadge } from './DiscountBadge.interfaces';
import { DiscountBadgeRegular } from './DiscountBadgeRegular';
import { DiscountBadgeSmall } from './DiscountBadgeSmall';
import { DiscountBadgeUrgent } from './DiscountBadgeUrgent';

/**
 * A discount badge presented on sale card, can have two variands, depends on location on a sale card
 */
const DiscountBadge: React.FunctionComponent<IDiscountBadge> = ({
  discountPrice,
  variant,
  showTooltip,
  discountTooltip,
}) => {
  /**
   * Return formatted discount price
   */
  const getFormattedDiscountPrice: () => string = () => {
    return `-${discountPrice}%`;
  };

  const formattedDiscountPrice: string = getFormattedDiscountPrice();

  switch (variant) {
    case DiscountBadgeVariant.urgent:
      return (
        <DiscountBadgeUrgent
          showTooltip={showTooltip}
          discountPrice={formattedDiscountPrice}
          discountTooltip={discountTooltip}
          dataAttributes={{ testid: 'discountBadgeUrgent' }}
        />
      );
    case DiscountBadgeVariant.regular:
      return (
        <DiscountBadgeRegular
          showTooltip={showTooltip}
          discountPrice={formattedDiscountPrice}
          discountTooltip={discountTooltip}
          dataAttributes={{ testid: 'discountBadgeRegular' }}
        />
      );
    case DiscountBadgeVariant.small:
      return (
        <DiscountBadgeSmall
          showTooltip={showTooltip}
          discountPrice={formattedDiscountPrice}
          discountTooltip={discountTooltip}
          dataAttributes={{ testid: 'discountBadgeSmall' }}
        />
      );
  }
};

export default DiscountBadge;
